module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 167);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 10:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"top":"align__top___23GkX alignItems-flexStart","middle":"align__middle___36vRU alignItems-center","bottom":"align__bottom___lPiYq alignItems-flexEnd"};

/***/ }),

/***/ 11:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrap":"general__wrap___kYC0C display-inlineBlock"};

/***/ }),

/***/ 13:
/***/ (function(module, exports) {

module.exports = require("lodash/pick");

/***/ }),

/***/ 167:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Textarea = exports.UnderlinedInput = exports.IconInput = undefined;

var _IconInput = __webpack_require__(168);

Object.defineProperty(exports, 'IconInput', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_IconInput).default;
  }
});

var _UnderlinedInput = __webpack_require__(177);

Object.defineProperty(exports, 'UnderlinedInput', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_UnderlinedInput).default;
  }
});

var _Textarea = __webpack_require__(181);

Object.defineProperty(exports, 'Textarea', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Textarea).default;
  }
});

var _Input = __webpack_require__(68);

var _Input2 = _interopRequireDefault(_Input);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Input2.default;

/***/ }),

/***/ 168:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _pick2 = __webpack_require__(13);

var _pick3 = _interopRequireDefault(_pick2);

var _noop = __webpack_require__(4);

var _noop2 = _interopRequireDefault(_noop);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _Input = __webpack_require__(68);

var _Input2 = _interopRequireDefault(_Input);

var _Icon = __webpack_require__(172);

var _Icon2 = _interopRequireDefault(_Icon);

var _Dismiss = __webpack_require__(174);

var _Dismiss2 = _interopRequireDefault(_Dismiss);

var _general = __webpack_require__(176);

var _general2 = _interopRequireDefault(_general);

var _type = __webpack_require__(25);

var _type2 = _interopRequireDefault(_type);

var _sizes = __webpack_require__(26);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Inputs have so many props that I don't even know what to write here feel me
 */
var IconInput = function (_Component) {
  _inherits(IconInput, _Component);

  function IconInput() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, IconInput);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = IconInput.__proto__ || Object.getPrototypeOf(IconInput)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isFocussed: false
    }, _this.onBlur = function (event) {
      _this.props.onBlur(event);
      _this.setState({
        isFocussed: false
      });
    }, _this.onFocus = function (event) {
      _this.props.onFocus(event);
      _this.setState({
        isFocussed: true
      });
    }, _this.onChange = function (event) {
      _this.props.onChange(event);
    }, _this.onClear = function () {
      _this.props.onClear();
      _this.setState({
        isFocussed: false
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(IconInput, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          size = _props.size,
          icon = _props.icon,
          _props$iconWidth = _props.iconWidth,
          iconWidth = _props$iconWidth === undefined ? _sizes.iconSize[size] : _props$iconWidth,
          isCompact = _props.isCompact,
          fullWidth = _props.fullWidth,
          hasError = _props.hasError,
          style = _props.style,
          value = _props.value;
      var isFocussed = this.state.isFocussed;

      var _pick = (0, _pick3.default)(this.props, Object.keys(_Input2.default.propTypes)),
          placeholder = _pick.placeholder,
          inputProps = _objectWithoutProperties(_pick, ['placeholder']);

      var height = _sizes.inputSize[size];
      var iconMargin = height - _sizes.iconSize[size];

      var containerClasses = (0, _classnames2.default)(_general2.default.container, {
        'width-100': fullWidth
      });

      var containerStyle = void 0;
      var newPlaceholder = void 0;
      var paddingLeft = void 0;
      var width = void 0;

      if (isCompact) {
        iconMargin = height - iconWidth; // visually center the icon when isExpanded = false
        newPlaceholder = isFocussed ? placeholder : '';
        var isExpanded = isFocussed || value;
        paddingLeft = isExpanded ? height : null;
        width = !isExpanded ? height : null;
        containerStyle = {
          color: !isExpanded && 'transparent',
          transition: 'none'
        };
      } else {
        newPlaceholder = placeholder;
        paddingLeft = iconWidth + iconMargin;
      }

      return _react2.default.createElement(
        'div',
        { className: containerClasses, style: containerStyle },
        _react2.default.createElement(_Input2.default, _extends({}, inputProps, {
          onBlur: this.onBlur,
          onFocus: this.onFocus,
          placeholder: newPlaceholder,
          onChange: this.onChange,
          paddingLeft: paddingLeft,
          width: width,
          value: value
        })),
        _react2.default.createElement(
          _Icon2.default,
          { hasError: hasError, isFocussed: isFocussed, margin: iconMargin },
          icon
        ),
        isCompact && value && _react2.default.createElement(_Dismiss2.default, { style: style, onClick: this.onClear })
      );
    }
  }]);

  return IconInput;
}(_react.Component);

exports.default = IconInput;


IconInput.propTypes = {
  fullWidth: _propTypes2.default.bool,
  hasError: _propTypes2.default.bool,
  icon: _propTypes2.default.element.isRequired,
  iconWidth: _propTypes2.default.number,
  isCompact: _propTypes2.default.bool,
  onChange: _propTypes2.default.func.isRequired,
  onFocus: _propTypes2.default.func,
  onBlur: _propTypes2.default.func,
  onClear: _propTypes2.default.func.isRequired,
  size: _propTypes2.default.oneOf(Object.keys(_sizes.iconSize)).isRequired,
  style: _propTypes2.default.oneOf(Object.keys(_type2.default)).isRequired,
  value: _propTypes2.default.string
};

IconInput.defaultProps = {
  fullWidth: false,
  hasError: false,
  isCompact: false,
  onChange: _noop2.default,
  onFocus: _noop2.default,
  onBlur: _noop2.default,
  onClear: _noop2.default,
  style: 'default'
};

/***/ }),

/***/ 169:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"input":"general__input___3ZFYB appearance-none borderWidth-0 outlineStyle-none transitionDuration-s transitionProperty-all transitionTimingFunction-ease-in-out verticalAlign-middle","is-disabled--default":"general__is-disabled--default___1DYDG bg-snow boxShadow-smoke c-silver cursor-default pointerEvents-none","is-disabled--blank":"general__is-disabled--blank___24P1X cursor-default pointerEvents-none","has-error":"general__has-error___2KKsK boxShadow-negative"};

/***/ }),

/***/ 170:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"position-left--title":"position__position-left--title___3aQHQ borderRadiusLeft-m","position-left--extraLarge":"position__position-left--extraLarge___34fTT borderRadiusLeft-m","position-left--large":"position__position-left--large___1u8SO borderRadiusLeft-m","position-left--medium":"position__position-left--medium___UJVQ1 borderRadiusLeft-s","position-left--small":"position__position-left--small___Ay57n borderRadiusLeft-s","position-left--extraSmall":"position__position-left--extraSmall___3gLAb borderRadiusLeft-s","position-right--title":"position__position-right--title___1qFxY borderRadiusRight-m","position-right--extraLarge":"position__position-right--extraLarge___2VOIH borderRadiusRight-m","position-right--large":"position__position-right--large___2f66h borderRadiusRight-m","position-right--medium":"position__position-right--medium___gXf8H borderRadiusRight-s","position-right--small":"position__position-right--small___gmhln borderRadiusRight-s","position-right--extraSmall":"position__position-right--extraSmall___1wND5 borderRadiusRight-s","position-middle--title":"position__position-middle--title___1T6ks borderRadius-0","position-middle--extraLarge":"position__position-middle--extraLarge___428v5 borderRadius-0","position-middle--large":"position__position-middle--large___3vCry borderRadius-0","position-middle--medium":"position__position-middle--medium___yiO3i borderRadius-0","position-middle--small":"position__position-middle--small___1mE-M borderRadius-0","position-middle--extraSmall":"position__position-middle--extraSmall___3vwtT borderRadius-0","position-solo--title":"position__position-solo--title___34ZOT borderRadius-m","position-solo--extraLarge":"position__position-solo--extraLarge___1Jrfr borderRadius-m","position-solo--large":"position__position-solo--large___11JzW borderRadius-m","position-solo--medium":"position__position-solo--medium___3PYkU borderRadius-s","position-solo--small":"position__position-solo--small___2RlJx borderRadius-s","position-solo--extraSmall":"position__position-solo--extraSmall___1RHat borderRadius-s"};

/***/ }),

/***/ 171:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"title":"size__title___OIExZ paddingLeftRight-xs","extraLarge":"size__extraLarge___3Zv0H fontSize-l","large":"size__large___3bO4o fontSize-m","medium":"size__medium___1zGJS fontSize-m","small":"size__small___363b1 fontSize-s","extraSmall":"size__extraSmall___3foE3 fontSize-xs"};

/***/ }),

/***/ 172:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Icon;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _icon = __webpack_require__(173);

var _icon2 = _interopRequireDefault(_icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Icon(_ref) {
  var children = _ref.children,
      hasError = _ref.hasError,
      isFocussed = _ref.isFocussed,
      margin = _ref.margin;

  var iconClasses = (0, _classnames2.default)(_icon2.default.icon, {
    'fill-marvel': !hasError && isFocussed,
    'fill-smoke--xd': !hasError && !isFocussed,
    'fill-negative': hasError
  });

  var iconStyle = {
    marginLeft: margin / 2
  };

  return _react2.default.createElement(
    'div',
    { className: iconClasses, style: iconStyle },
    children
  );
}

Icon.propTypes = {
  children: _propTypes2.default.node.isRequired,
  hasError: _propTypes2.default.bool,
  isFocussed: _propTypes2.default.bool,
  margin: _propTypes2.default.number
};

Icon.defaultProps = {
  hasError: false,
  isFocussed: false,
  margin: 0
};

/***/ }),

/***/ 173:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"icon":"icon__icon___92aE9 pinTL pointerEvents-none verticallyCenter-absolute"};

/***/ }),

/***/ 174:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Dismiss;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _dismiss = __webpack_require__(175);

var _dismiss2 = _interopRequireDefault(_dismiss);

var _type = __webpack_require__(25);

var _type2 = _interopRequireDefault(_type);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Dismiss(_ref) {
  var onClick = _ref.onClick,
      style = _ref.style;

  var iconClasses = (0, _classnames2.default)(_dismiss2.default.close, {
    'marginRight-xs': style !== 'invisible'
  });

  return _react2.default.createElement(
    'div',
    { className: iconClasses, onClick: onClick },
    _react2.default.createElement(
      'div',
      { className: _dismiss2.default.center },
      _react2.default.createElement(
        'svg',
        { className: _dismiss2.default.icon, width: '8', height: '8', viewBox: '0 0 8 8' },
        _react2.default.createElement('path', { d: 'M4 2.752l-2.492-2.492c-.341-.341-.904-.346-1.249-.001-.347.347-.344.904.001 1.249l2.492 2.492-2.492 2.492c-.345.345-.348.902-.001 1.249.345.345.908.34 1.249-.001l2.492-2.492 2.492 2.492c.341.341.904.346 1.249.001.347-.347.344-.904-.001-1.249l-2.492-2.492 2.492-2.492c.345-.345.348-.902.001-1.249-.345-.345-.908-.34-1.249.001l-2.492 2.492z' })
      )
    )
  );
}

Dismiss.propTypes = {
  onClick: _propTypes2.default.func,
  style: _propTypes2.default.oneOf(Object.keys(_type2.default)).isRequired
};

Dismiss.defaultProps = {
  onClick: null
};

/***/ }),

/***/ 175:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"close":"dismiss__close___wLAOG bg-marvel--hover bg-snow--xd borderRadius-circle cursor-pointer fill-silver fill-white--hover position-absolute searchInputClose transitionDuration-s transitionProperty-all transitionTimingFunction-linear","center":"dismiss__center___YkLnw pinCenter position-absolute","icon":"dismiss__icon___33qCJ display-block"};

/***/ }),

/***/ 176:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"general__container___1Q0K0 cf display-inlineBlock position-relative transitionDuration-l"};

/***/ }),

/***/ 177:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bind = __webpack_require__(3);

var _bind2 = _interopRequireDefault(_bind);

var _noop = __webpack_require__(4);

var _noop2 = _interopRequireDefault(_noop);

var _pick2 = __webpack_require__(13);

var _pick3 = _interopRequireDefault(_pick2);

var _TickSmall = __webpack_require__(37);

var _TickSmall2 = _interopRequireDefault(_TickSmall);

var _InlineGrid = __webpack_require__(9);

var _InlineGrid2 = _interopRequireDefault(_InlineGrid);

var _general = __webpack_require__(178);

var _general2 = _interopRequireDefault(_general);

var _size = __webpack_require__(179);

var _size2 = _interopRequireDefault(_size);

var _placeholder = __webpack_require__(180);

var _placeholder2 = _interopRequireDefault(_placeholder);

var _sizes = __webpack_require__(26);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var cx = _bind2.default.bind(_extends({}, _general2.default, _placeholder2.default, _size2.default));

var tickSizes = {
  extraSmall: 8,
  small: 10,
  medium: 12,
  large: 14,
  extraLarge: 16
};

var tickSpacing = {
  extraSmall: 2,
  small: 3,
  medium: 4,
  large: 5,
  extraLarge: 6
};

var UnderlinedInput = function (_Component) {
  _inherits(UnderlinedInput, _Component);

  function UnderlinedInput() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, UnderlinedInput);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = UnderlinedInput.__proto__ || Object.getPrototypeOf(UnderlinedInput)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      hasValue: false || _this.props.value,
      isFocussed: false
    }, _this.onBlur = function (event) {
      _this.props.onBlur(event);
      _this.setState({
        isFocussed: false
      });
    }, _this.onFocus = function (event) {
      _this.props.onFocus(event);
      _this.setState({
        isFocussed: true
      });
    }, _this.onChange = function (event) {
      _this.props.onChange(event);
      if (event.target.value) {
        _this.setState({
          hasValue: true
        });
      } else {
        _this.setState({
          hasValue: false
        });
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(UnderlinedInput, [{
    key: 'render',
    value: function render() {
      var _cx, _cx2, _cx3;

      var _pick = (0, _pick3.default)(this.props, Object.keys(UnderlinedInput.propTypes)),
          disabled = _pick.disabled,
          fullWidth = _pick.fullWidth,
          hasError = _pick.hasError,
          id = _pick.id,
          name = _pick.name,
          onBlur = _pick.onBlur,
          onChange = _pick.onChange,
          onFocus = _pick.onFocus,
          paddingLeft = _pick.paddingLeft,
          placeholder = _pick.placeholder,
          showTick = _pick.showTick,
          size = _pick.size,
          width = _pick.width,
          withRef = _pick.withRef,
          rest = _objectWithoutProperties(_pick, ['disabled', 'fullWidth', 'hasError', 'id', 'name', 'onBlur', 'onChange', 'onFocus', 'paddingLeft', 'placeholder', 'showTick', 'size', 'width', 'withRef']);

      var _state = this.state,
          isFocussed = _state.isFocussed,
          hasValue = _state.hasValue;


      var wrapClasses = cx(_general2.default.wrap, {
        'width-100': fullWidth
      });

      var inputClasses = cx(_general2.default.input, size, (_cx = {}, _defineProperty(_cx, _general2.default.default, !hasError && !disabled), _defineProperty(_cx, _general2.default.hasError, hasError && !disabled), _defineProperty(_cx, _general2.default.isDisabled, disabled), _defineProperty(_cx, 'width-100', fullWidth), _cx));

      var inputStyle = {
        height: _sizes.underlineInputSize[size],
        lineHeight: _sizes.underlineInputSize[size] + 'px'
      };

      var placeholderClasses = cx('placeholderWrap', (_cx2 = {}, _defineProperty(_cx2, _placeholder2.default.default, !((isFocussed || hasValue) && !hasError)), _defineProperty(_cx2, _placeholder2.default.isFocussed, (isFocussed || hasValue) && !hasError), _defineProperty(_cx2, _placeholder2.default.hasError, hasError && !disabled), _defineProperty(_cx2, _placeholder2.default.isDisabled, disabled), _defineProperty(_cx2, size, !isFocussed && !hasValue), _defineProperty(_cx2, size + '-isFocussed', isFocussed || hasValue), _cx2));

      var labelSize = cx((_cx3 = {}, _defineProperty(_cx3, size, !isFocussed && !hasValue), _defineProperty(_cx3, size + '-isFocussed', isFocussed || hasValue), _cx3));

      var labelStyle = {
        paddingRight: tickSpacing[size]
      };

      return _react2.default.createElement(
        'div',
        { className: wrapClasses },
        _react2.default.createElement('input', _extends({
          className: inputClasses,
          id: id,
          name: name,
          onBlur: this.onBlur,
          onChange: this.onChange,
          onFocus: this.onFocus,
          placeholder: null,
          ref: withRef,
          style: inputStyle,
          disabled: disabled
        }, rest)),
        _react2.default.createElement(
          'label',
          { htmlFor: id, className: placeholderClasses },
          _react2.default.createElement(
            _InlineGrid2.default,
            { size: 'none' },
            _react2.default.createElement(
              'span',
              { className: labelSize, style: labelStyle },
              placeholder
            ),
            showTick && hasValue && _react2.default.createElement(_TickSmall2.default, { size: tickSizes[size] })
          )
        )
      );
    }
  }]);

  return UnderlinedInput;
}(_react.Component);

exports.default = UnderlinedInput;


UnderlinedInput.propTypes = {
  autoComplete: _propTypes2.default.string,
  autoFocus: _propTypes2.default.bool,
  defaultValue: _propTypes2.default.string,
  disabled: _propTypes2.default.bool,
  fullWidth: _propTypes2.default.bool,
  hasError: _propTypes2.default.bool,
  id: _propTypes2.default.string,
  maxLength: _propTypes2.default.number,
  name: _propTypes2.default.string,
  onBlur: _propTypes2.default.func,
  onChange: _propTypes2.default.func,
  onFocus: _propTypes2.default.func,
  onKeyDown: _propTypes2.default.func,
  onKeyPress: _propTypes2.default.func,
  onKeyUp: _propTypes2.default.func,
  onPaste: _propTypes2.default.func,
  paddingLeft: _propTypes2.default.number,
  placeholder: _propTypes2.default.string,
  showTick: _propTypes2.default.bool,
  size: _propTypes2.default.oneOf(Object.keys(_size2.default)).isRequired,
  tabIndex: _propTypes2.default.number,
  type: _propTypes2.default.oneOf(['color', 'date', 'datetime-local', 'datetime', 'email', 'file', 'month', 'number', 'password', 'range', 'search', 'tel', 'text', 'time', 'url', 'week']).isRequired,
  value: _propTypes2.default.string,
  withRef: _propTypes2.default.func,
  width: _propTypes2.default.number
};

UnderlinedInput.defaultProps = {
  disabled: false,
  fullWidth: false,
  hasError: false,
  onBlur: _noop2.default,
  onChange: _noop2.default,
  onFocus: _noop2.default,
  placeholer: '',
  position: 'solo',
  showTick: false,
  size: 'medium',
  type: 'text',
  width: null
};

/***/ }),

/***/ 178:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrap":"general__wrap___2JE8Z display-inlineBlock position-relative","input":"general__input___3CJnf appearance-none bg-none borderBottomWidth-1 borderStyle-solid borderWidth-0 c-slate outlineStyle-none transitionDuration-s transitionProperty-all transitionTimingFunction-ease-in-out verticalAlign-middle","default":"general__default___1DV9I borderColor-marvel--focus borderColor-smoke--xd--hover borderColor-smoke","hasError":"general__hasError___10h7k borderColor-red","isDisabled":"general__isDisabled___2eCvx borderColor-snow--xd"};

/***/ }),

/***/ 179:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"extraLarge":"size__extraLarge___1Y8gx fontSize-xl","large":"size__large___3xzRr fontSize-l","medium":"size__medium___3UiAD fontSize-m","small":"size__small___3WNKt fontSize-s","extraSmall":"size__extraSmall___Le6ZY fontSize-xs"};

/***/ }),

/***/ 180:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"placeholderWrap":"placeholder__placeholderWrap___5WbzS pointerEvents-none position-absolute transitionDuration-xl transitionTimingFunction-cv-easeOutCircular width-100","extraLarge-isFocussed":"placeholder__extraLarge-isFocussed___3ypBi fontSize-l","large-isFocussed":"placeholder__large-isFocussed___2JHVK fontSize-m","medium-isFocussed":"placeholder__medium-isFocussed___UzRRD fontSize-s","small-isFocussed":"placeholder__small-isFocussed___tjgFb fontSize-xs","extraSmall-isFocussed":"placeholder__extraSmall-isFocussed___2v9L7 fontSize-xxs","default":"placeholder__default___2p5r5 c-silver","isFocussed":"placeholder__isFocussed___2p1S3 c-black","hasError":"placeholder__hasError___2VnKW c-red","isDisabled":"placeholder__isDisabled___25760 c-silver"};

/***/ }),

/***/ 181:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = Textarea;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _bind = __webpack_require__(3);

var _bind2 = _interopRequireDefault(_bind);

var _pick2 = __webpack_require__(13);

var _pick3 = _interopRequireDefault(_pick2);

var _general = __webpack_require__(182);

var _general2 = _interopRequireDefault(_general);

var _position = __webpack_require__(183);

var _position2 = _interopRequireDefault(_position);

var _size = __webpack_require__(184);

var _size2 = _interopRequireDefault(_size);

var _type = __webpack_require__(185);

var _type2 = _interopRequireDefault(_type);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var cx = _bind2.default.bind(_extends({}, _general2.default, _position2.default, _size2.default, _type2.default));

function Textarea(props) {
  var _cx;

  var _pick = (0, _pick3.default)(props, Object.keys(Textarea.propTypes)),
      disabled = _pick.disabled,
      fullWidth = _pick.fullWidth,
      hasError = _pick.hasError,
      paddingLeft = _pick.paddingLeft,
      position = _pick.position,
      size = _pick.size,
      style = _pick.style,
      width = _pick.width,
      withRef = _pick.withRef,
      centered = _pick.centered,
      minHeight = _pick.minHeight,
      rest = _objectWithoutProperties(_pick, ['disabled', 'fullWidth', 'hasError', 'paddingLeft', 'position', 'size', 'style', 'width', 'withRef', 'centered', 'minHeight']);

  var textareaClasses = cx('textarea', 'position-' + position + '--' + size, size, (_cx = {}, _defineProperty(_cx, style, !(hasError || disabled)), _defineProperty(_cx, 'has-error', hasError), _defineProperty(_cx, 'is-disabled--default', disabled && style !== 'editable'), _defineProperty(_cx, 'is-disabled--blank', disabled && style === 'editable'), _defineProperty(_cx, 'width-100', fullWidth), _defineProperty(_cx, 'textAlign-center', centered), _cx));

  var textareaStyle = {
    minHeight: minHeight,
    paddingLeft: paddingLeft && paddingLeft,
    width: width && width
  };

  return _react2.default.createElement('textarea', _extends({
    className: textareaClasses,
    ref: withRef,
    style: textareaStyle
  }, rest));
}

Textarea.propTypes = {
  autoComplete: _propTypes2.default.string,
  autoFocus: _propTypes2.default.bool,
  centered: _propTypes2.default.bool,
  defaultValue: _propTypes2.default.string,
  disabled: _propTypes2.default.bool,
  fullWidth: _propTypes2.default.bool,
  hasError: _propTypes2.default.bool,
  id: _propTypes2.default.string,
  maxLength: _propTypes2.default.number,
  minHeight: _propTypes2.default.number,
  name: _propTypes2.default.string,
  onBlur: _propTypes2.default.func,
  onChange: _propTypes2.default.func,
  onFocus: _propTypes2.default.func,
  onKeyDown: _propTypes2.default.func,
  onKeyPress: _propTypes2.default.func,
  onKeyUp: _propTypes2.default.func,
  onPaste: _propTypes2.default.func,
  paddingLeft: _propTypes2.default.number,
  placeholder: _propTypes2.default.string,
  position: _propTypes2.default.oneOf(['left', 'right', 'middle', 'solo']),
  size: _propTypes2.default.oneOf(Object.keys(_size2.default)).isRequired,
  style: _propTypes2.default.oneOf(Object.keys(_type2.default)).isRequired,
  tabIndex: _propTypes2.default.number,
  type: _propTypes2.default.oneOf(['color', 'date', 'datetime-local', 'datetime', 'email', 'file', 'month', 'number', 'password', 'range', 'search', 'tel', 'text', 'time', 'url', 'week']).isRequired,
  value: _propTypes2.default.string,
  withRef: _propTypes2.default.func,
  width: _propTypes2.default.number
};

Textarea.defaultProps = {
  disabled: false,
  fullWidth: false,
  centered: false,
  hasError: false,
  placeholer: '',
  position: 'solo',
  size: 'medium',
  style: 'default',
  type: 'text',
  width: null
};

/***/ }),

/***/ 182:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"textarea":"general__textarea___p1UnY appearance-none borderWidth-0 outlineStyle-none transitionDuration-s transitionProperty-all transitionTimingFunction-ease-in-out verticalAlign-middle","is-disabled--default":"general__is-disabled--default___1lGM8 bg-snow boxShadow-smoke c-silver cursor-default pointerEvents-none","is-disabled--blank":"general__is-disabled--blank___100-T cursor-default pointerEvents-none","has-error":"general__has-error___10PUk boxShadow-negative"};

/***/ }),

/***/ 183:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"position-left--title":"position__position-left--title___3KIf1 borderRadiusLeft-m","position-left--extraLarge":"position__position-left--extraLarge___1E5_l borderRadiusLeft-m","position-left--large":"position__position-left--large___1sZ3G borderRadiusLeft-m","position-left--medium":"position__position-left--medium___2bH8T borderRadiusLeft-s","position-left--small":"position__position-left--small___2kFI0 borderRadiusLeft-s","position-left--extraSmall":"position__position-left--extraSmall___7rPBL borderRadiusLeft-s","position-right--title":"position__position-right--title___BZNOg borderRadiusRight-m","position-right--extraLarge":"position__position-right--extraLarge___2F3A0 borderRadiusRight-m","position-right--large":"position__position-right--large___3TQpP borderRadiusRight-m","position-right--medium":"position__position-right--medium___ZHZAo borderRadiusRight-s","position-right--small":"position__position-right--small___1xWxg borderRadiusRight-s","position-right--extraSmall":"position__position-right--extraSmall___3H943 borderRadiusRight-s","position-middle--title":"position__position-middle--title___jmZ5m borderRadius-0","position-middle--extraLarge":"position__position-middle--extraLarge___eB9C- borderRadius-0","position-middle--large":"position__position-middle--large___2GUfl borderRadius-0","position-middle--medium":"position__position-middle--medium___2gv2a borderRadius-0","position-middle--small":"position__position-middle--small___tNqKJ borderRadius-0","position-middle--extraSmall":"position__position-middle--extraSmall___3L4Tu borderRadius-0","position-solo--title":"position__position-solo--title___24aSH borderRadius-m","position-solo--extraLarge":"position__position-solo--extraLarge___1Hjya borderRadius-m","position-solo--large":"position__position-solo--large___1BAQK borderRadius-m","position-solo--medium":"position__position-solo--medium___3VE1b borderRadius-s","position-solo--small":"position__position-solo--small___3G_Cc borderRadius-s","position-solo--extraSmall":"position__position-solo--extraSmall___3F0Qt borderRadius-s"};

/***/ }),

/***/ 184:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"title":"size__title___T5lB9 paddingLeftRight-xs","extraLarge":"size__extraLarge___2i5I_ fontSize-l","large":"size__large___3TUeF fontSize-m","medium":"size__medium___oBGMk fontSize-m","small":"size__small___2l-h0 fontSize-s","extraSmall":"size__extraSmall___22GAr fontSize-xs"};

/***/ }),

/***/ 185:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"default":"type__default___1lMuc bg-white boxShadow-marvel--focus boxShadow-smoke--xd--hover boxShadow-smoke c-slate","invisible":"type__invisible___Lg822 bg-none c-slate","editable":"type__editable___1a6lv bg-none boxShadow-marvel--focus boxShadow-smoke--hover c-slate fontWeight-5","invisibleReversed":"type__invisibleReversed___35YDt bg-none c-white"};

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("classnames");

/***/ }),

/***/ 25:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"default":"type__default___3KlrT bg-white boxShadow-marvel--focus boxShadow-smoke--xd--hover boxShadow-smoke c-slate","invisible":"type__invisible___19KQZ bg-none c-slate","editable":"type__editable___2WwKy bg-none boxShadow-marvel--focus boxShadow-smoke--hover c-slate fontWeight-5","invisibleReversed":"type__invisibleReversed___1iTFh bg-none c-white"};

/***/ }),

/***/ 26:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var inputSize = {
  extraLarge: 60,
  large: 50,
  medium: 40,
  small: 30,
  extraSmall: 24
};

var iconSize = {
  extraLarge: 36,
  large: 30,
  medium: 24,
  small: 18,
  extraSmall: 16
};

var underlineInputSize = {
  extraLarge: 50,
  large: 40,
  medium: 36,
  small: 30,
  extraSmall: 20
};

exports.inputSize = inputSize;
exports.iconSize = iconSize;
exports.underlineInputSize = underlineInputSize;

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("classnames/bind");

/***/ }),

/***/ 37:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = TickSmall;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _tick = __webpack_require__(69);

var _tick2 = _interopRequireDefault(_tick);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function TickSmall(_ref) {
  var size = _ref.size;

  var containerSize = {
    width: size,
    height: size
  };
  var iconSize = {
    width: size / 2,
    height: size / 2
  };
  return _react2.default.createElement(
    'div',
    { className: _tick2.default.container, style: containerSize },
    _react2.default.createElement(
      'svg',
      _extends({}, iconSize, { className: _tick2.default.tick, viewBox: '0 0 8 8' }),
      _react2.default.createElement('path', { d: 'M7.54,1.06a1.2,1.2,0,0,0-1.68.2L3.05,4.37l-1-.76A1.2,1.2,0,0,0,.3,5.19l2,1.6a1.2,1.2,0,0,0,1.85,0l3.6-4a1.2,1.2,0,0,0-.2-1.68' })
    )
  );
}

TickSmall.propTypes = {
  size: _propTypes2.default.number
};

TickSmall.defaultProps = {
  size: 16
};

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = require("lodash/noop");

/***/ }),

/***/ 68:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = Input;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _bind = __webpack_require__(3);

var _bind2 = _interopRequireDefault(_bind);

var _pick2 = __webpack_require__(13);

var _pick3 = _interopRequireDefault(_pick2);

var _general = __webpack_require__(169);

var _general2 = _interopRequireDefault(_general);

var _position = __webpack_require__(170);

var _position2 = _interopRequireDefault(_position);

var _size = __webpack_require__(171);

var _size2 = _interopRequireDefault(_size);

var _type = __webpack_require__(25);

var _type2 = _interopRequireDefault(_type);

var _sizes = __webpack_require__(26);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var cx = _bind2.default.bind(_extends({}, _general2.default, _position2.default, _size2.default, _type2.default));

function Input(props) {
  var _cx;

  var _pick = (0, _pick3.default)(props, Object.keys(Input.propTypes)),
      disabled = _pick.disabled,
      fullWidth = _pick.fullWidth,
      hasError = _pick.hasError,
      paddingLeft = _pick.paddingLeft,
      position = _pick.position,
      size = _pick.size,
      style = _pick.style,
      width = _pick.width,
      withRef = _pick.withRef,
      centered = _pick.centered,
      rest = _objectWithoutProperties(_pick, ['disabled', 'fullWidth', 'hasError', 'paddingLeft', 'position', 'size', 'style', 'width', 'withRef', 'centered']);

  var inputClasses = cx('input', 'position-' + position + '--' + size, size, (_cx = {}, _defineProperty(_cx, style, !(hasError || disabled)), _defineProperty(_cx, 'has-error', hasError), _defineProperty(_cx, 'is-disabled--default', disabled && style !== 'editable'), _defineProperty(_cx, 'is-disabled--blank', disabled && style === 'editable'), _defineProperty(_cx, 'width-100', fullWidth), _defineProperty(_cx, 'textAlign-center', centered), _cx));

  var inputStyle = {
    height: _sizes.inputSize[size],
    paddingLeft: paddingLeft && paddingLeft,
    width: width && width
  };

  return _react2.default.createElement('input', _extends({
    className: inputClasses,
    ref: withRef,
    style: inputStyle
  }, rest));
}

Input.propTypes = {
  autoComplete: _propTypes2.default.string,
  autoFocus: _propTypes2.default.bool,
  defaultValue: _propTypes2.default.string,
  disabled: _propTypes2.default.bool,
  centered: _propTypes2.default.bool,
  fullWidth: _propTypes2.default.bool,
  hasError: _propTypes2.default.bool,
  id: _propTypes2.default.string,
  maxLength: _propTypes2.default.number,
  name: _propTypes2.default.string,
  onBlur: _propTypes2.default.func,
  onChange: _propTypes2.default.func,
  onFocus: _propTypes2.default.func,
  onKeyDown: _propTypes2.default.func,
  onKeyPress: _propTypes2.default.func,
  onKeyUp: _propTypes2.default.func,
  onPaste: _propTypes2.default.func,
  paddingLeft: _propTypes2.default.number,
  placeholder: _propTypes2.default.string,
  position: _propTypes2.default.oneOf(['left', 'right', 'middle', 'solo']),
  size: _propTypes2.default.oneOf(Object.keys(_size2.default)).isRequired,
  style: _propTypes2.default.oneOf(Object.keys(_type2.default)).isRequired,
  tabIndex: _propTypes2.default.number,
  type: _propTypes2.default.oneOf(['color', 'date', 'datetime-local', 'datetime', 'email', 'file', 'month', 'number', 'password', 'range', 'search', 'tel', 'text', 'time', 'url', 'week']).isRequired,
  value: _propTypes2.default.string,
  withRef: _propTypes2.default.func,
  width: _propTypes2.default.number
};

Input.defaultProps = {
  disabled: false,
  fullWidth: false,
  centered: false,
  hasError: false,
  placeholer: '',
  position: 'solo',
  size: 'medium',
  style: 'default',
  type: 'text',
  width: null
};

/***/ }),

/***/ 69:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"tick__container___1vXxR bg-positive borderRadius-circle display-inlineBlock position-relative","tick":"tick__tick___3MPPt fill-white pinCenter position-absolute"};

/***/ }),

/***/ 9:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = InlineGrid;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bind = __webpack_require__(3);

var _bind2 = _interopRequireDefault(_bind);

var _align = __webpack_require__(10);

var _align2 = _interopRequireDefault(_align);

var _general = __webpack_require__(11);

var _general2 = _interopRequireDefault(_general);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var cx = _bind2.default.bind(_extends({}, _align2.default, _general2.default));

/**
 * A simpler grid implementation for when you need to quickly inline elements.
 * The optional `size` prop is available as well as vertical alignment with the
 * `align` prop.
 */
function InlineGrid(_ref) {
  var align = _ref.align,
      children = _ref.children,
      size = _ref.size,
      sizeL = _ref.sizeL,
      sizeM = _ref.sizeM,
      sizeS = _ref.sizeS,
      startAfterL = _ref.startAfterL,
      startAfterM = _ref.startAfterM,
      startAfterS = _ref.startAfterS;

  var wrappedChildren = _react.Children.map(children, function (child, index) {
    var _cx;

    if (!child) {
      return null;
    }
    var lastChild = children.length - 1 === index;
    var className = cx((_cx = {}, _defineProperty(_cx, 'marginBottom-' + size, !lastChild && (startAfterS || startAfterM || startAfterL)), _defineProperty(_cx, 'marginRight-' + size, !lastChild && !startAfterS && !startAfterM && !startAfterL), _defineProperty(_cx, 'breakPointS-marginRight-' + sizeS, !lastChild && sizeS), _defineProperty(_cx, 'breakPointM-marginRight-' + sizeM, !lastChild && sizeM), _defineProperty(_cx, 'breakPointL-marginRight-' + sizeL, !lastChild && sizeL), _defineProperty(_cx, 'breakPointS-marginBottom-0', !lastChild && startAfterS), _defineProperty(_cx, 'breakPointM-marginBottom-0', !lastChild && startAfterM), _defineProperty(_cx, 'breakPointL-marginBottom-0', !lastChild && startAfterL), _cx));
    return _react2.default.createElement(
      'div',
      { key: index, className: className },
      child
    );
  });

  var containerClasses = cx([align], {
    'display-flex': !startAfterS && !startAfterM && !startAfterL,
    'breakPointS-display-flex': startAfterS,
    'breakPointM-display-flex': startAfterM,
    'breakPointL-display-flex': startAfterL
  });

  return _react2.default.createElement(
    'div',
    { className: _general2.default.wrap },
    _react2.default.createElement(
      'div',
      { className: containerClasses },
      wrappedChildren
    )
  );
}

InlineGrid.propTypes = {
  align: _propTypes2.default.oneOf(['top', 'middle', 'bottom']),
  children: _propTypes2.default.node.isRequired,
  size: _propTypes2.default.oneOf(['xl', 'l', 'm', 's', 'xs', 'xxs', 'none']),
  sizeL: _propTypes2.default.oneOf(['xl', 'l', 'm', 's', 'xs', 'xxs', 'none']),
  sizeM: _propTypes2.default.oneOf(['xl', 'l', 'm', 's', 'xs', 'xxs', 'none']),
  sizeS: _propTypes2.default.oneOf(['xl', 'l', 'm', 's', 'xs', 'xxs', 'none']),
  startAfterS: _propTypes2.default.bool,
  startAfterM: _propTypes2.default.bool,
  startAfterL: _propTypes2.default.bool
};

InlineGrid.defaultProps = {
  align: 'middle',
  size: 'm',
  startAfterS: false,
  startAfterM: false,
  startAfterL: false
};

/***/ })

/******/ });
//# sourceMappingURL=marvel-ui-input.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@marvelapp/marvel-ui/lib/marvel-ui-input.js
// module id = 1104
// module chunks = 168707334958949